import { BrowserRouter,Route,Routes } from 'react-router-dom';
import Header2 from './Components/Header/index2';
import Home from "./Pages/Home";
import Produits from "./Pages/Produits";
import Realisations from "./Pages/Realisations";
import ProduitsFamilles from "./Pages/ProduitsFamilles"
import RealisationsFamilles from './Pages/RealisationsFamilles';
import Contacts from './Pages/Contacts';
import RealisationsDetail from './Pages/RealisationsDetail';
function App() {

  return (
    <div className="App">
 <BrowserRouter>
      <Header2/>
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route path='/nos-produits' element={<Produits/>} />
        <Route path='/nos-produits/:name' element={<ProduitsFamilles/>} />
       
        <Route path='/nos-realisations' element={<Realisations/>} />
        <Route path='/nos-realisations/:name' element={<RealisationsFamilles/>} />
         <Route path='/:name' element={<RealisationsDetail/>} />
        <Route path='/contact' element={<Contacts/>} />
          </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
